import styled from "styled-components";

export const HeaderButtonsContainer = styled.div`
  margin-left: auto;
  margin-right: 0;
`;

